import {makeGet} from '@yandex-delivery/utils'

import type {PaymentMethodActualStateResponse} from '../types'

export const paymentMethodActualStateGetter = makeGet<PaymentMethodActualStateResponse>()
